import React from 'react';
import { track } from '../lib/track';

const SiteFooter: React.FC = () => (
  <footer className="site-footer">
    <div className="site-footer__note">
      <span className="site-footer__badge">OPEN TO WORK</span>
      mujahid@masood ~ {new Date().getFullYear()} · DE
    </div>
    <div className="site-footer__links">
      <a
        href="/Mujahid_Masood_Resume.pdf"
        download="Mujahid_Masood_Resume.pdf"
        onClick={() => track('cv_download', { source: 'footer' })}
      >
        [cv ⇩]
      </a>
      <a href="https://github.com/mujahidmasood" target="_blank" rel="noreferrer">[github]</a>
      <a href="https://www.linkedin.com/in/mujahidmasood/" target="_blank" rel="noreferrer">[linkedin]</a>
      <a href="mailto:mujahid.mms@gmail.com">[email]</a>
    </div>
  </footer>
);

export default SiteFooter;
